import { useCallback, useState } from 'react';
import { ApiError } from '../api/client';
import { useToast } from '../components/Toast';

/**
 * სერვერის შეცდომების ერთგვაროვანი დამუშავება:
 * ველების შეცდომები ფორმაში ჩნდება, ზოგადი — toast-ში.
 */
export function useFormErrors() {
  const toast = useToast();
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});

  const reset = useCallback(() => setFieldErrors({}), []);

  const handle = useCallback(
    (err: unknown, fallback = 'ოპერაცია ვერ შესრულდა') => {
      if (err instanceof ApiError) {
        setFieldErrors(err.details ?? {});
        // თუ კონკრეტული ველი დასახელებულია, ფორმაში უკვე ჩანს
        if (!err.details || Object.keys(err.details).length === 0) {
          toast.error(err.message);
        }
        return;
      }
      toast.error(fallback);
    },
    [toast],
  );

  return { fieldErrors, setFieldErrors, reset, handle };
}
